import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useState } from 'react';
import { Box } from '@mui/material';
import { BoilerFailPane } from './components/fail-card';
import { SwiperWithModal } from 'console/shared/components/modals/swiper';
import { OTBoilerStateCard } from 'console/shared/components/dialogs/ot-boiler-state/card';
import { createSubsetSelector } from 'webui/utils/selectors';
import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { usePartial } from 'shared/hooks/utils';
import { select_z3k_boiler_adapters, selectLegacyBoilerAdapters } from './selectors';
import { isLegacyDevice } from 'console/shared/contexts/device/config/utils';
import { OTLegacyBoilerStateCard } from 'console/shared/components/dialogs/ot-boiler-state/legacy';
import { SwipableModalHeader } from '../../modals/swipable/header';
import { validateDeviceConfig } from 'console/shared/content/device/utils';
import { selectorSelectedDevice } from 'entities/device/lib';
const device_selector = createSelector(selectorSelectedDevice, createSubsetSelector([
    'id',
    'z3k_config',
    'z3k_state',
    'device_type',
    'last_boiler_state',
    'thermostat_zones_settings',
    'otzones_last',
    'ot_zones_count',
    'ot_enabled',
    'ot_boiler_type',
    'boiler_info',
]));
export const FailureCards = memo(function FailureCards() {
    const device = useAppSelector(device_selector);
    if (device == null) {
        return null;
    }
    return _jsx(FailureCardsImpl, { device: device });
});
const FailureCardsImpl = memo(function FailureCardsImpl(props) {
    const { device } = props;
    const z3k_boiler_adapters = select_z3k_boiler_adapters(device);
    const legacy_boiler_adapters = selectLegacyBoilerAdapters(device);
    const [open_id, setOpenId] = useState(null);
    const onClose = usePartial(setOpenId, null);
    const is_legacy = isLegacyDevice(device.device_type);
    const boiler_adapters = validateDeviceConfig(is_legacy ? legacy_boiler_adapters : z3k_boiler_adapters) || [];
    const initial_slide = boiler_adapters.findIndex(({ id }) => id == open_id);
    const component = useCallback((boiler_adapter, drag_handler, onClose) => {
        const { id, ot_boiler_state, boiler_type, not_available_ot_flags, boiler_model, } = boiler_adapter;
        const { name, ot_state, id: boiler_adapter_id } = ot_boiler_state || {};
        return (_jsxs(Box, { flexDirection: "column", height: "100%", children: [_jsx(SwipableModalHeader, { name: name ?? 'Неизвестный адаптер', onClose: onClose, drag_handler: drag_handler }), is_legacy ? (_jsx(OTLegacyBoilerStateCard, { device_id: device.id, boiler_adapter_id: boiler_adapter_id, last_boiler_adapter_state: ot_state, not_available_ot_flags: not_available_ot_flags, boiler_type: boiler_type })) : (_jsx(OTBoilerStateCard, { device_id: device.id, boiler_adapter_id: boiler_adapter_id, last_boiler_adapter_state: ot_state, boiler_type: boiler_type, not_available_ot_flags: not_available_ot_flags, boiler_model: boiler_model }))] }, id));
    }, [device.id, is_legacy]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", maxHeight: "200px", sx: { overflowY: 'scroll' }, children: [boiler_adapters.map(({ id, name, ot_boiler_state, is_fail, boiler_model, boiler_type }) => (_jsx(BoilerFailPane, { name: name, ot_state: ot_boiler_state?.ot_state, boiler_model: boiler_model, ba_protocol: boiler_type, fail: is_fail, onClick: () => setOpenId(id ?? -1) }, id))), _jsx(SwiperWithModal, { opened: initial_slide >= 0, onClose: onClose, initialSlide: initial_slide, items: boiler_adapters, component: component })] }));
});
